var _module = require('../../components/module');

require('angular-ui-bootstrap/src/modal');
require('../lr-touch');
require('../../components/window-height');

_module.requires.push('ui.bootstrap.module.modal');

_module.service('$firstFilterModal', [
    '$log',
    '$uibModal',

    function $firstFilterModalService($log, $uibModal) {
        /*
        @function openFirstFilterModal
        */
        return function openFirstFilterModal(sfilter) {
            var modal = $uibModal.open({
                animation: false,
                template: require('./index.html'),
                controller: ['$scope', function firstFilterModalCtrl($scope) {
                    try {
                        $scope.sfilter = JSON.parse(JSON.stringify(sfilter || {}));
                    } catch(err) {
                        $scope.$dismiss(err);
                    }


                    $scope.submitFilterName = function () {
                        var res = ($scope.sfilter.name !== sfilter.name)
                                    ? $scope.sfilter.name
                                    : '';

                        $scope.$close(res);
                    };
                }],
                backdrop: 'static',
                windowClass: 'first-filter-modal'
            });

            return modal.result;
        };
    }
]);
